/* Pasyu — custom vanilla JS. One init per component, all guarded. */
(function () {
  'use strict';

  /* This file is included once per ps- section, so it can load several times
     on a page. Only wire everything up once. */
  if (window.__psScriptsInit) return;
  window.__psScriptsInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.ps-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ps-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var siblings = el.parentElement ? el.parentElement.querySelectorAll(':scope > .ps-reveal') : [el];
        var idx = Array.prototype.indexOf.call(siblings, el);
        el.style.setProperty('--ps-delay', (idx > 0 ? Math.min(idx, 6) * 80 : 0) + 'ms');
        el.classList.add('ps-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- count-up numbers ---------- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-ps-count]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-ps-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-ps-count'));
        var suffix = el.getAttribute('data-ps-suffix') || '';
        var dur = 1400, start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- FAQ accordion (JS height animation, works everywhere) ---------- */
  function initFaq() {
    var items = document.querySelectorAll('.ps-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.ps-faq__q');
      var panel = item.querySelector('.ps-faq__a');
      if (!btn || !panel) return;

      if (item.getAttribute('aria-expanded') === 'true') {
        panel.style.height = 'auto';
      }

      btn.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        if (panel._psDone) { panel.removeEventListener('transitionend', panel._psDone); panel._psDone = null; }

        if (reduceMotion) {
          item.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.style.height = open ? '0px' : 'auto';
          return;
        }

        /* pin to current pixel height before changing */
        panel.style.height = panel.getBoundingClientRect().height + 'px';
        void panel.offsetHeight; /* reflow */

        if (open) {
          panel.style.height = '0px';
          item.setAttribute('aria-expanded', 'false');
        } else {
          item.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.scrollHeight + 'px';
          panel._psDone = function () {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', panel._psDone);
            panel._psDone = null;
          };
          panel.addEventListener('transitionend', panel._psDone);
        }
      });
    });
  }

  /* ---------- duplicate marquee track for seamless loop ---------- */
  function initMarquee() {
    var tracks = document.querySelectorAll('.ps-reviews__track');
    if (!tracks.length) return;
    tracks.forEach(function (track) {
      if (track.dataset.psCloned) return;
      var kids = Array.prototype.slice.call(track.children);
      kids.forEach(function (kid) {
        var c = kid.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
      track.dataset.psCloned = '1';
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var gal = document.querySelector('[data-ps-gallery]');
    if (!gal) return;
    var main = gal.querySelector('.ps-gallery__main img');
    var thumbs = gal.querySelectorAll('.ps-gallery__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- product variants ---------- */
  function initVariants() {
    var root = document.querySelector('[data-ps-variants]');
    if (!root) return;
    var dataEl = document.getElementById('ps-variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-ps-price]');
    var compareEl = root.querySelector('[data-ps-compare]');
    var saveEl = root.querySelector('[data-ps-save]');
    var addBtn = root.querySelector('[data-ps-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-ps-add-label]') : null;
    var soldOutText = root.getAttribute('data-sold-out') || 'Sold out';
    var addText = root.getAttribute('data-add-text') || 'Add to cart';
    var selected = {};
    var firstRun = true;

    var gal = document.querySelector('[data-ps-gallery]');
    var galMain = gal ? gal.querySelector('.ps-gallery__main img') : null;
    var galThumbs = gal ? gal.querySelectorAll('.ps-gallery__thumb') : [];

    function showMedia(mediaId) {
      if (!galMain || !mediaId) return;
      var target = null;
      galThumbs.forEach(function (t) {
        if (String(t.getAttribute('data-media-id')) === String(mediaId)) target = t;
      });
      if (!target) return;
      var full = target.getAttribute('data-full');
      if (full) galMain.src = full;
      galThumbs.forEach(function (t) { t.setAttribute('aria-current', t === target ? 'true' : 'false'); });
    }

    function match() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function update() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (!firstRun) showMedia(v.media_id);
      firstRun = false;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (compareEl) {
        if (v.on_sale) {
          compareEl.textContent = v.compare_formatted;
          compareEl.hidden = false;
          if (saveEl) { saveEl.textContent = '-' + v.discount + '%'; saveEl.hidden = false; }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? addText : soldOutText;
      }
    }

    root.querySelectorAll('[data-ps-opt]').forEach(function (group) {
      var optIndex = parseInt(group.getAttribute('data-ps-opt'), 10);
      var pills = group.querySelectorAll('.ps-buy__pill');
      pills.forEach(function (pill) {
        if (pill.getAttribute('aria-pressed') === 'true') selected[optIndex] = pill.getAttribute('data-value');
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
          selected[optIndex] = pill.getAttribute('data-value');
          var lbl = group.querySelector('[data-ps-opt-current]');
          if (lbl) lbl.textContent = pill.getAttribute('data-value');
          update();
        });
      });
    });
    update();
  }

  function boot() {
    initReveals();
    initCounters();
    initFaq();
    initMarquee();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
